import React from "react";
import { Chip as MUIChip, ChipProps } from "@mui/material";

export const DKChip = (props: ChipProps & { to?: string }) => {
  return (
    <MUIChip
      {...props}
      size="small"
      variant="outlined"
      sx={{
        ...props.sx,
        backgroundColor: "white",
      }}
    />
  );
};
